import Vue from 'vue'
import Vuex from 'vuex'
import {commonApi} from "../axios/index.js"

Vue.use(Vuex)

let state = {
  nav: '0',
  otherStatus:'1',
  webStatus: '0',
  ossCloudName:''
}

// 触发事件
let actions = {
  navData ({ commit }, data) {
    commit('setNavStatus', data)
  },
  otherStatusData ({ commit }, data){
    commit('setOtherStatus', data)
  },
  webStatusData({ commit }, data){
    commit('setWebStatus', data)
  },
  ossCloudNameData({ commit }, data){
      return new Promise((resolve, reject) => {
        commonApi.getOssCloudName().then(res => {
          if (res.data) { // 验证返回的roles是否是一个非空数组
            commit('setOssCloudName', res.data)
          } else {
            commit('setOssCloudName', '')
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
  }
}

// 改变
let mutations = {
  setNavStatus(state, data){
    state.nav = data
  },
  setOtherStatus(state, data){
    state.otherStatus = data
  },
  setWebStatus(state, data){
    state.webStatus = data
  },
  setOssCloudName(state, data){
    state.ossCloudName = data
  }
}

// 获取
let getters = {
  getNavStatus: state => {
    return state.nav
  },
  getOtherStatus: state => {
    return state.otherStatus
  },
  getWebStatus: state => {
    return state.webStatus
  },
  getOssCloudName: state => {
    return state.ossCloudName
  }
}

const store = new Vuex.Store({
    state,
    actions,
    mutations,
    getters
})

export default store
// export default function createStore () {
//   return new Vuex.Store({
//     state,
//     actions,
//     mutations,
//     getters
//   })
// }



// WEBPACK FOOTER //
// ./src/store/index.js